import React, { ReactNode, forwardRef } from "react";

export interface Props {
  children: ReactNode;
  className?: string;
}

export const Modal = forwardRef<HTMLDivElement, Props>(
  ({ children, className }, ref) => (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
);
